import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BsTelephoneFill, BsSearch } from "react-icons/bs";
import { FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import { MdCalendarToday } from "react-icons/md";
import "./ComponentsStyles/Navbar01.css";
import logo from "../Assets/logo.png";
import CountrySelector from "./CountrySelector";
import { FaSuitcaseMedical } from "react-icons/fa6";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(true);
  const [atTop, setAtTop] = useState(true);

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY <= 0) {
        setScrolled(true);
        setAtTop(true);
      } else if (currentScrollY > lastScrollY) {
        setScrolled(false);
        setAtTop(false);
      } else {
        setScrolled(true);
        setAtTop(false);
      }

      lastScrollY = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleBookAppointment = (e) => {
    e.preventDefault();
    alert(
      `This feature is under development. The booking system will be available shortly.`
    );
  };

  const openGmailCompose = (e) => {
    // must be synchronous and called directly by click
    e.preventDefault();

    const email = "info@rbdiagnostics.com";
    const subject = ""; // set default subject if you want
    const body = ""; // set default body if you want

    // Gmail web compose URL
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
      email
    )}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    // Try opening Gmail in a new tab/window
    const newWin = window.open(gmailUrl, "_blank", "noopener,noreferrer");

    if (newWin) {
      // opened successfully
      newWin.focus();
    } else {
      // popup blocked — fallback to default mail client via mailto:
      // this will open the user's configured mail app (Gmail if set as handler)
      window.location.href = `mailto:${email}?subject=${encodeURIComponent(
        subject
      )}&body=${encodeURIComponent(body)}`;
    }
  };

  return (
    <div
      className={`NavbarDiv ${atTop ? "atthetop" : ""} ${scrolled ? "" : "navbar-hidden"
        }`}
    >
      <div className="leftNavSection">
        <div className="logoSection">
          <Link to="/">
            <img src={logo} alt="logo" style={{ cursor: "pointer" }} />
          </Link>
        </div>
        <div className="playStoreSection">
          <div className="buttons">
            <Link
              to="https://play.google.com/store/apps/details?id=com.rblis.itsdose&hl=en"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                alt="Google Play"
              />
            </Link>
            <Link
              to="https://apps.apple.com/us/app/rb-patient-app/id1602372001"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                alt="App Store"
              />
            </Link>
          </div>
        </div>
        {/*<div className="contactSection">
          <BsTelephoneFill
            style={{
              fontSize: "1.2rem",
              color: "#0fb7a4",
              paddingTop: "0.5rem",
            }}
          />
          <div className="phoneNumbers">
            <p>033-4085 4085</p>
            <p>033-3382 3382</p>
          </div>
          {/* <div
            className="mailId"
            onClick={() => {
             
              window.location.href = "mailto:info@rbdiagnostics.com";
            }}
            style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          >
            <FaEnvelope
              style={{
                fontSize: "1.2rem",
                color: "#0fb7a4",
                marginRight: "0.5rem",
              }}
            />
            <p style={{ margin: 0 }}>info@rbdiagnostics.com</p>
          </div> *}

        
        <div>
              <a
            href="mailto:info@rbdiagnostics.com"
            onClick={openGmailCompose}
            className="mailId"
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              textDecoration: "none",
              color: "inherit",
            }}
          >
            <FaEnvelope
              style={{
                fontSize: "1.2rem",
                color: "#0fb7a4",
                marginRight: "0.5rem",
              }}
            />
            <span style={{ margin: 0, color: "#353636ff" }}>
              info@rbdiagnostics.com
            </span>
          </a>
          <p class="m-0" style={{color:'#353636ff',fontSize:'0.9rem'}}><FaSuitcaseMedical /> Mon - Sat: 06:30 am - 08:30 pm</p>
           <p class="m-0" style={{color:'#353636ff',fontSize:'0.9rem'}}><FaSuitcaseMedical />  Sun: 06:30 am - 2 pm</p>

        </div>
        </div>*/}


        <div className="contactSection">

          {/* LEFT: Phone + Email */}
          <div className="contactLeft">
            <div className="phoneRow">
              <BsTelephoneFill
                style={{
                  fontSize: "1rem",
                  color: "#0fb7a4",
                  paddingTop: "0.5rem",
                }}
              />
              <div>
                <p>033-4085 4085</p>
                <p>033-3382 3382</p>
              </div>
            </div>

            {/* <a
      href="mailto:info@rbdiagnostics.com"
      onClick={openGmailCompose}
      className="emailRow"
    >
      <FaEnvelope
              style={{
                fontSize: "1rem",
                color: "#0fb7a4",
                marginRight: "0.5rem",
              }}
            />
      <span>info@rbdiagnostics.com</span>
    </a> */}
          </div>

          {/* RIGHT: Timings */}
          <div className="contactCenter">
            <a
              href="mailto:info@rbdiagnostics.com"
              onClick={openGmailCompose}
              className="emailRow"
            >
              <FaEnvelope
                style={{
                  fontSize: "1rem",
                  color: "#0fb7a4",
                  marginRight: "0.5rem",
                }}
              />
              <span>info@rbdiagnostics.com</span>
            </a>
          </div>

          <div className="contactRight">

            <div className="custom-grid-box">
              <div><FaSuitcaseMedical
                style={{
                  fontSize: "1rem",
                  color: "#0fb7a4",
                  marginRight: "0.5rem",
                }}
              /></div>
              <div> Mon - Sat: 6:30 AM - 8:30 PM
                <br />
                Sun: 6:30 AM - 2.00 PM</div>
            </div>

            {/* <p><FaSuitcaseMedical 
     style={{
                fontSize: "1rem",
                color: "#0fb7a4",
                marginRight: "0.5rem",
              }}
            /> Mon - Sat: 06:30 am - 08:30 pm
           <br/>
               Sun: 06:30 am - 2 pm</p> */}
          </div>

        </div>





        <div className="nablAndCountry">
          <div className="rightNavSection">
            <img
              src="https://rbdiagnostic.com/assets/img/nabl-logo.png"
              alt="NABL Logo"
              className="nablLogo"
            />
          </div>

          <div className="rightNavSection">
            <div className="rightLeftSection">
              <CountrySelector />
            </div>
            <div className="rightButtonSection">
              {/* <button>
            <span className="btn-text" onClick={handleBookAppointment}>
              <MdCalendarToday /> Make an Appointment
            </span>
            <span></span>
          </button> */}
              {/* <span style={{color:'#0fb7a4',fontSize:'0.8rem'}}><FaSuitcaseMedical /> Mon - Sun: 06:15 am - 08:30 pm</span> */}
            </div>
          </div>
        </div>







      </div>

      {/* <div className="rightNavSection">
        <div></div>
      </div> */}
    </div>
  );
};

export default Navbar;
